module.exports = __webpack_public_path__ + "assets/1b.png";


//////////////////
// WEBPACK FOOTER
// ./images/1b.png
// module id = 694
// module chunks = 0